module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("67yho"))).then(() => parcelRequire('9Lwss'));